<template>
  <cargo-packing-select
    :default-value="value"
    v-bind="$attrs"
    v-on="new$listeners"
    @change="onChange"
  />
</template>

<script>
import cargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'

export default {
  name: 'CargoPackingSelectStandard',
  components: {
    cargoPackingSelect
  },
  props: {
    value: { type: [String, Number], required: true }
  },
  computed: {
    new$listeners() {
      const result = { ...this.$listeners }
      delete result.change
      return result
    }
  },
  methods: {
    onChange(data) {
      this.$emit('input', data.value)
      this.$emit('change', data.value)
    }
  }
}
</script>
